import { Plus, X } from 'lucide-react';
import { useAgentContext } from '@Providers';

import HeaderPreferencesButton from './HeaderPreferencesButton';
import ModeSwitcher from './ModeSwitcher';

interface HeaderActionsProps {
  onNewConversation?: () => void;
}

const IconButton = ({
  ariaLabel,
  onClick,
  children,
}: {
  ariaLabel: string;
  onClick?: () => void;
  children: React.ReactNode;
}) => (
  <button
    type="button"
    aria-label={ariaLabel}
    title={ariaLabel}
    onClick={onClick}
    className="flex h-7 w-7 items-center justify-center rounded-md text-gray-500 cursor-pointer transition-colors duration-200 hover:bg-[#7c6cf6]/10 hover:text-[#7c6cf6] focus:outline-none">
    {children}
  </button>
);

const HeaderActions = ({ onNewConversation }: HeaderActionsProps) => {
  const { setIsOpen } = useAgentContext();

  return (
    <div className="flex items-center gap-1">
      <IconButton ariaLabel="New conversation" onClick={onNewConversation}>
        <Plus size={15} strokeWidth={1.75} />
      </IconButton>
      <HeaderPreferencesButton />
      <ModeSwitcher />
      <IconButton ariaLabel="Close" onClick={() => setIsOpen(false)}>
        <X size={15} strokeWidth={1.75} />
      </IconButton>
    </div>
  );
};

export default HeaderActions;
